import Client from "./client";

// Unauthenticated - the pricing section of the landing page and the plan
// picker on sign-up both run before anyone has an account.
//
// The tier table isn't duplicated in the frontend on purpose: these are the
// same Plan rows the API enforces limits from, so a price or a limit can only
// be changed in one place.

export const GetPublicPlans = () => {
    return new Promise((resolve, reject) => {
        Client.get('/api/public/plans').then((res) => {
            resolve(res.data);
        }).catch((e) => {
            reject(e.response?.data || {error: "Something went wrong loading plans. Please try again."});
        })
    })
}
